import React from 'react'
import InputTextField from './InputTextField'

const InputPrenom = ({
  error,
  ...others
}) => {
  return (
    <InputTextField
      error={error}
      label="Prénom"
      inputProps={{
        style: {
          textTransform: 'capitalize'
        }
      }}
      helperText={
        (error)
          ? "Ce prénom est invalide"
          : null
      }
      {...others}
    />
  )
}

export default InputPrenom
